import { SimpleSelectElement, SimpleSelectElementProps } from 'components/molecules';
import { journalTexts } from 'consts/text';
import { LessonDTO } from 'types';
import { formFields } from 'consts/form/formFields';
import { useMemo } from 'react';
import { parseStringIntoDayName } from 'utils/parsers/dateTime/parseStringIntoDayName';

type LessonPickerProps = {
    specialLessonsData?: LessonDTO[];
    onChange: (topic?: LessonDTO) => void;
    isLoading: boolean;
    disabled?: boolean;
} & Pick<SimpleSelectElementProps, 'hidden'>;

export const LessonPicker = ({
    specialLessonsData,
    onChange,
    isLoading,
    disabled,
    hidden,
}: LessonPickerProps) => {
    const lessonsOptions = useMemo(
        () =>
            specialLessonsData?.map((lesson) => {
                const formattedTime = lesson.timeFrom.slice(0, -3);
                return {
                    value: lesson.id,
                    label: `${lesson.course?.name} ${parseStringIntoDayName(lesson.date)}
                 ${formattedTime}`,
                };
            }),
        [specialLessonsData],
    );

    const onLessonChange = (lessonId: string) => {
        const selectedTopic = specialLessonsData?.find((lesson) => lesson.id === lessonId);
        onChange(selectedTopic);
    };

    return (
        <SimpleSelectElement
            name={formFields.lessonId}
            label={journalTexts.journalDetails.groupJournal.topics.lessonLabel}
            options={lessonsOptions}
            loading={isLoading}
            disabled={disabled}
            hidden={hidden}
            onChange={onLessonChange}
        />
    );
};
